<template>
  <div>
    <div class="yazdirtable">
      <div v-for="d in data" v-if="d.Ekstre">
        <h1>[{{ d.Bilgi.Kat }} Kat {{ d.Bilgi.kNo }} No] {{ d.Bilgi.AdSoyad }} Kişi Ekstresi</h1>
        <table class="table table-bordered">
          <thead>
          <tr>
            <th>Tarih</th>
            <th>Türü</th>
            <th>Evrak</th>
            <th>Açıklama</th>
            <th class="text-right">Emanet</th>
            <th class="text-right">Zam</th>
            <th class="text-right">Borç</th>
            <th class="text-right">Ödenen</th>
            <th class="text-right">Kalan</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="e in d.Ekstre">
            <td>{{ e.Tarih }}</td>
            <td>{{ e.Tur }}</td>
            <td>{{ e.eNo }}</td>
            <td>{{ e.Aciklama }}</td>
            <td class="text-right">{{ e.Emanet }}</td>
            <td class="text-right">{{ e.Zam }}</td>
            <td class="text-right">{{ e.Borc }}</td>
            <td class="text-right">{{ e.Odenen }}</td>
            <td class="text-right">{{ e.Kalan }}</td>
          </tr>
          </tbody>
          <tfoot>
          <tr>
            <td colspan="4"></td>
            <td class="text-right">{{ d.AltToplam.Emanet }}</td>
            <td class="text-right">{{ d.AltToplam.Zam }}</td>
            <td class="text-right">{{ d.AltToplam.Borc }}</td>
            <td class="text-right">{{ d.AltToplam.Odenen }}</td>
            <td class="text-right">{{ d.AltToplam.Kalan }}</td>
          </tr>
          </tfoot>
        </table>
        <div class="sayfasonu"></div>
      </div>
    </div>
    <el-tabs type="border-card" class="tab-p0 yazdirma">
      <el-tab-pane v-for="d in data" :lazy=true v-if="d.Ekstre">
        <span slot="label">[{{ d.Bilgi.Kat }} Kat {{ d.Bilgi.kNo }} No] {{ d.Bilgi.AdSoyad }}</span>
        <RaporlamaKisiEkstre :data="d"></RaporlamaKisiEkstre>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import RaporlamaKisiEkstre from "../../../components/Pack/Raporlama/RaporlamaKisiEkstre";
export default {
  props:['data'],
  components: {RaporlamaKisiEkstre}
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/Raporlama/kisi/KisiEkstre.vue